import * as React from 'react';
import { Button } from '@mc/react-core';
import classNames from 'classnames';

const ClassNameNS = 'app-button-secondary';
const ClassName = ` ${ClassNameNS}`;

type Props = Omit<
  React.ComponentProps<typeof Button>,
  'active' | 'intent' | 'outlined'
> & {
  fixedWidth?: boolean;
};

export class SecondaryButton extends React.PureComponent<Props> {
  render() {
    const { className, fixedWidth, ...other } = this.props;

    return (
      <Button
        className={classNames(className, ClassName, {
          [`app-button-fw`]: fixedWidth,
        })}
        {...other}
      />
    );
  }
}
